<template>
    <div>
        <el-table
            row-key="id"
            :data="dataRow"
            size="mini"
            ref="productTable"
            border
        >
            <el-table-column label="中文品名" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.product_cn_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="英文品名" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.product_en_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="产品数量" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.product_number }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Asin" align="center">
                <template slot-scope="scope">
                    <div>{{ getAsin(scope.row.product_detail_id).asin || '' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="海关编码" align="center">
                <template slot-scope="scope">
                    <div>{{ getAsin(scope.row.product_detail_id).customs_code || '' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="重" align="center">
                <template slot-scope="scope">
                    <div>{{ getAsin(scope.row.product_detail_id).weight || '' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="单价" align="center">
                <template slot-scope="scope">
                    <div>{{ getAsin(scope.row.product_detail_id).price || '' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="品牌" align="center">
                <template slot-scope="scope">
                    <div>{{ getAsin(scope.row.product_detail_id).brand || '' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="材质" align="center">
                <template slot-scope="scope">
                    <div>{{ getAsin(scope.row.product_detail_id).material || '' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="用途" align="center">
                <template slot-scope="scope">
                    <div>{{ getAsin(scope.row.product_detail_id).purpose || '' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="230" align="center" v-if="!isPreview">
                <template slot-scope="scope">
                    <div @click.stop>
                        <el-button style="margin: 5px 0 5px 10px" size="mini" type="primary"
                                   @click.native="updateProdInfo(2, scope.row, scope.$index)">
                            修改产品信息
                        </el-button>

                        <el-button style="margin: 5px 0 5px 10px" size="mini" type="danger"
                                   @click.native="deleteProdInfo(2, scope.row, scope.$index)">
                            删除产品
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

    </div>
</template>

<script>
    export default {
        name: 'productTable',
        props: {
            'dataRow': {
                type: Array,
                default: []
            },
            'asinList': {
                type: Array,
                default: []
            },
            'boxIndex': {
                type: Number,
                default: 0
            },
            'isPreview': {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {}
        },
        methods: {
            getAsin(id) {
                for (const item of this.asinList) {
                    if (item.id == id) {
                        return item
                    }
                }
                return {}
            },
            updateProdInfo(type, data, index) {
                this.$emit('updateBoxInner', type, JSON.parse(JSON.stringify(data)), this.boxIndex, index)
            },
            deleteProdInfo(type, data, index) {
                this.$confirm(`确定删除此产品吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$delete(this.dataRow, index)
                }).catch(() => {
                })
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
